import React, { useCallback } from "react";
import { Checkbox, FormControlLabel, ListItem, Radio } from "@mui/material";

import "./style.scss";

export interface IQuickFilterOptionProps {
    children: string;
    component?: "radio" | "checkbox";
    value: string;
    count: number;
    onClick?: (isChecked: boolean) => void;
    isChecked?: boolean;
}

export const QuickFilterOption = (props: IQuickFilterOptionProps) => {
    const handleChange = useCallback((isChecked: boolean) => {
        if (props.onClick) {
            props.onClick(isChecked);
        }
    }, [props.onClick]);

    return <ListItem className={"quick-filter-option__item"}>
        <FormControlLabel control={props.component === "checkbox" ?
            <Checkbox checked={props.isChecked ?? false} size={"small"} /> :
            <Radio checked={props.isChecked ?? false} size={"small"} />}
                          onChange={(_event, isChecked) => handleChange(isChecked)}
                          label={<span className={"quick-filter-option__label"}>
                              {props.children} ({props.count})</span>}
                          data-testid={`filter-option-${props.value}`}/>
    </ListItem>;
};
